import React from "react";
import ComponentWrapper from "../Shared/ComponentWrapper";
import governedByTheCommunity from "../../data/Governed-by-the-community";
import LottieAnimation from "../Shared/LottieAnimation";

const Community = () => {
  return (
    <ComponentWrapper styles="pt-[3rem]">
      <div id="governance" className="w-full border-t-none sm:border-t-[1px] border-b-none sm:border-b-[1px] border-gray-1/30 pb-[4rem] flex flex-col justify-center items-center ">
        <div className="w-full h-[190px] sm:h-[320px]">
          <LottieAnimation
            animationData={governedByTheCommunity}
            width="100%"
            height="100%"
          />
        </div>
        <div className="flex flex-col gap-4">
          <h2 className="text-[40px] leading-[48px] text-center text-black font-medium">
            Shaped by the community.
          </h2>
          <p className="text-[18px] max-w-[620px] text-center text-gray-1 font-normal">
            Helix AI evolves through community input. New chain integrations,
            agent capabilities, and platform improvements are driven by HLX
            token holders who shape the future of autonomous blockchain interaction.
          </p>
          <div className="flex justify-center items-center pt-4">
            <a
              href="https://ai.helix.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[14px] font-semibold text-white h-[46px] rounded-[12px] bg-blue-1 px-6
                       transition-all duration-200 ease-in-out
                      shadow-md hover:shadow-lg active:shadow-sm
                      transform hover:scale-105 active:scale-95 flex items-center justify-center"
            >
              Join the Community
            </a>
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
};

export default Community;
